import { useCallback, useState } from "react";
import { Space, DatePicker, Button, Dropdown } from "antd";
import styled from "styled-components";
import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DatePickerProps } from "antd";
import { FilterOutlined } from "@ant-design/icons";

dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

export default function FilterTime({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) {
  const [filterActive, setFilterActive] = useState("Filter month");
  const dateFormat = "YYYY/MM/DD";
  const handleChange = (data) => {
    setFilterActive(data);
  };

  const items = [
    {
      key: "1",
      label: (
        <div onClick={() => handleChange("Filter month")}>Filter month</div>
      ),
    },
    {
      key: "2",
      label: <div onClick={() => handleChange("Filter date")}>Filter date</div>,
    },
  ];

  const FilterDateMonth = useCallback(() => {
    return (
      <div className="filter">
        <Dropdown menu={{ items }} arrow>
          <Button>
            {filterActive}
            <FilterOutlined />
          </Button>
        </Dropdown>
      </div>
    );
  }, [filterActive]);

  const handleDateChange = (dates = []) => {
    if (dates) {
      const formatStartDate = dayjs(dates[0]).format("YYYY-MM-DD");
      const formatEndDate = dayjs(dates[1]).format("YYYY-MM-DD");
      setStartDate(formatStartDate);
      setEndDate(formatEndDate);
    }
  };

  const disabledDate = (current) => {
    const today = new Date();
    return current && current > today;
  };
  return (
    <ContainerFilterTimer>
      <Space className="d-flex" direction="vertical" size={12}>
        <RangePicker
          defaultValue={[
            dayjs(endDate, dateFormat),
            dayjs(startDate, dateFormat),
          ]}
          format={dateFormat}
          onChange={handleDateChange}
          disabledDate={disabledDate}
          className= "filter-time"
        />
      </Space>
      {/* <div className="icon-filter">{FilterDateMonth()}</div> */}
    </ContainerFilterTimer>
  );
}

const ContainerFilterTimer = styled(Space)`
  display: flex;

  .icon-filter {
    padding-left: 30px;
  }

  .ant-btn.ant-btn-default {
    color: rgb(73 65 65 / 88%) !important;
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: 14px;
  }


`;
